import React from "react";
import { Controls, FormGroup, IFormStyles, useFormStyles } from "../.";
import { FormGroupProps, FormGroupType } from "../misc/formGroup";

interface FormAutocompleteProps extends Controls.ControlAutocompleteProps {
    isLoading?: boolean | undefined
    groupType?: FormGroupType | undefined;

    label?: string | undefined
    isOptional?: boolean | undefined;
    tooltip?: string | undefined;
}

const ComponentProps = (props: FormAutocompleteProps): Controls.ControlAutocompleteProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.groupType;

    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
}

const GroupProps = (props: FormAutocompleteProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: props.groupType,

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };
    
    return groupProps;
}

export const FormAutocomplete: React.FC<FormAutocompleteProps> = (props) => {
    const styles: IFormStyles = useFormStyles();
    
    return (
        <FormGroup  {...GroupProps(props)}>
            <Controls.ControlAutocomplete {...ComponentProps(props)} controlStyles={styles.control} />        
        </FormGroup>
        
    );
};